import { normalizeTextString } from '../normalizeTextString';
import { calculatePrefixPath } from './calculate-prefixed-path';
import { DictionarySubDirectories } from './get-url-subdirectories';

const CONTENT_TYPE_MAP: any = {
  MeetingPlacePageTenantEntertainment:
    'ContentfulMeetingPlacePageTenantEntertainmentItem',
  MeetingPlacePageTenantShop: 'ContentfulMeetingPlacePageTenantShopItem',
  MeetingPlacePageTenantFoodBeverage:
    'ContentfulMeetingPlacePageTenantFoodBevItem',
  MeetingPlacePageOffer: 'ContentfulMeetingPlacePageOfferItem',
  MeetingPlacePageEvent: 'ContentfulMeetingPlacePageEventItem',
  MeetingPlacePageNewsItem: 'ContentfulMeetingPlacePageNewsItem',
  MeetingPlacePageService: 'ContentfulMeetingPlacePageServiceItem',
  MeetingPlacePageLeisurePackageOfferItem:
    'ContentfulMeetingPlacePageLeisurePackageOfferItem',
  LibraryServiceType: 'ContentfulLibraryServiceType',
};

export const calculateLanguageHandledPath = (
  dictionarySlugData: any,
  pageLocale: string,
  pageSlug: string,
  pageContentType: string,
  prefix: string,
): string => {
  const matchDictionarySubDirectories = dictionarySlugData.find(
    (subDir: any) =>
      subDir?.findIndex(
        (urlSubDir: any) => urlSubDir.sys.locale === pageLocale,
      ) > -1,
  );

  const matchDictionarySubDirectory = matchDictionarySubDirectories?.find(
    (subDirectory: any) =>
      subDirectory.contentTypes.includes(CONTENT_TYPE_MAP[pageContentType]),
  );

  const pagePrefixAndLocale = calculatePrefixPath(
    `/${pageLocale.toLocaleLowerCase()}`,
    prefix,
  );

  if (matchDictionarySubDirectory) {
    return `${pagePrefixAndLocale}/${normalizeTextString(
      matchDictionarySubDirectory.urlSubdirectory,
      true,
    )}/${normalizeTextString(pageSlug, true)}`;
  } else {
    return `${pagePrefixAndLocale}/${normalizeTextString(pageSlug, true)}`;
  }
};
